import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';

import { EnumOpenDialog } from '../../../stores/ui/types';
import { useStores } from '../../../stores/useStores';
import Button from '../../buttons/Button';
import { Dialog } from '../../Dialog/Dialog';
import { HeaderWithLogo } from '../DialogHeaders/HeaderWithLogo/HeaderWithLogo';

import classes from './PurchaseLimitDialog.module.scss';

const PurchaseLimitIncreaseDialog = observer(() => {
  const { uiStore } = useStores();
  const { t } = useTranslation();
  const isOpen = uiStore.openDialog.dialog === EnumOpenDialog.isOpenPurchaseLimitIncreaseDialog;

  return (
    <Dialog
      className={classNames('purchase-limit-increase-dialog', classes.purpleBg)}
      headerReplacement={<HeaderWithLogo title={t('payments.purchaseLimit')} />}
      isOpen={isOpen}
      title={t('payments.purchaseLimit')}
      onClose={() => uiStore.setCloseDialog()}
    >
      <div className={classes.purchaseLimitIncrease}>
        <div className={classes.topText} data-testid="purchase-limit-top-text">
          <Trans
            components={{
              intro: <span />,
              amount: <span className={classNames(classes.textBold, classes.textLightGray)} />,
              limit: <span className={classNames(classes.textBold, classes.textOrange)} />,
            }}
            i18nKey="payments.creditCardLimitSentence"
          />
        </div>
        <div className={classNames(classes.bottomText, classes.textBold)}>
          <span data-testid="purchase-limit-increase-line">
            <Trans
              components={{ accent: <span className={classes.textGreen} /> }}
              i18nKey="payments.toIncreaseTheLimit"
            />
          </span>
          <span data-testid="purchase-limit-gift-line">
            <Trans
              components={{ accent: <span className={classes.textGreen} /> }}
              i18nKey="payments.andGetAGiftSentence"
            />
          </span>
          <span>{t('payments.fillAdditionalDetails')}</span>
        </div>
        <Button btnType="main" className={classes.increaseBtn}>
          {t('payments.increaseLimitUpperCase')}
        </Button>
        <div className={classes.remark}>{t('payments.differentPaymentMethods')}</div>
      </div>
    </Dialog>
  );
});

export default PurchaseLimitIncreaseDialog;
